import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth, isSubscriptionActive } from "@/lib/auth";
import UpgradeScreen from "@/pages/UpgradeScreen";
import { Loader2 } from "lucide-react";

export function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-background">
        <Loader2 className="w-6 h-6 animate-spin text-brand-purple" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return <Outlet />;
}

export function SubscriptionGuard({ children }) {
  const { user } = useAuth();
  if (!user) return children; // ProtectedRoute already gated this
  if (isSubscriptionActive(user)) return children;
  const reason = user.subscription_status === "none" ? "trial" : "expired";
  return <UpgradeScreen reason={reason} />;
}
